import { EArticleClass, IArticleDetail } from 'shared/models';
import { ClickPosition } from '~/utils/click-position';
import { usePageActive } from '~/utils/active/use-page-active';
import { useCallback } from 'react';
import { Article, ArticleClass } from '@lemon8/webapp-seo-shared';

export const useActiveToArticle = (article: IArticleDetail): ((position: ClickPosition, id?: string) => void) => {
  const active = usePageActive();

  return useCallback(
    (position, id) => {
      const {
        articleClass,
        groupId,
        author: { userId },
      } = article;

      active({
        schemaOption: {
          pageType: articleClass === EArticleClass.VIDEO ? 'video' : 'article',
          groupId,
          authorId: userId,
        },
        ampExtra: {
          enter_position: position,
          enter_page_click_id: id || null,
        },
      });
    },
    [active, article],
  );
};

export const useActiveToArticleAuthor = (article: IArticleDetail): ((position: ClickPosition, id?: string) => void) => {
  const active = usePageActive();

  return useCallback(
    (position, id) => {
      const {
        author: { userId },
      } = article;

      active({
        schemaOption: {
          pageType: 'user',
          userId,
        },
        ampExtra: {
          enter_position: position,
          enter_page_click_id: id || null,
        },
      });
    },
    [active, article],
  );
};

export const useActiveToArticleBySimpleArticle = (
  article: Article,
): ((position: ClickPosition, id?: string) => void) => {
  const active = usePageActive();

  return useCallback(
    (position, id) => {
      const {
        articleClass,
        groupId,
        author: { userId },
      } = article;

      active({
        schemaOption: {
          pageType: articleClass === ArticleClass.VIDEO ? 'video' : 'article',
          groupId,
          authorId: userId,
        },
        ampExtra: {
          enter_position: position,
          enter_page_click_id: id || null,
        },
      });
    },
    [active, article],
  );
};
